import React, { Suspense, useMemo } from 'react'
import { graphql } from 'babel-plugin-relay/macro'
import { useSuspenseFragment } from 'react-relay-offline'
import { csx } from '@vtex/admin-ui'

import { ProductPromotionHighlight } from '../../../core/components'
import type { ProductSkuHighlightedPromotion_ProductSku$key } from './__generated__/ProductSkuHighlightedPromotion_ProductSku.graphql'

const productSkuFragment = graphql`
  fragment ProductSkuHighlightedPromotion_ProductSku on ProductSku {
    id
    promotions(addresses: $addresses) {
      edges {
        node {
          id
          name
          highlight
        }
      }
    }
  }
`

type ProductSkuHighlightedPromotionContentProps = {
  productSkuRef: ProductSkuHighlightedPromotion_ProductSku$key
}

const ProductSkuHighlightedPromotionContent = ({
  productSkuRef,
}: ProductSkuHighlightedPromotionContentProps) => {
  const productSku = useSuspenseFragment(productSkuFragment, productSkuRef)

  // TODO: create util inline fragment
  const promotions = useMemo(() => {
    return productSku.promotions?.edges.map((promotionEdge) => ({
      id: promotionEdge.node.id,
      name: promotionEdge.node.name,
      highlight: !!promotionEdge.node.highlight,
    }))
  }, [productSku.promotions?.edges])

  if (!promotions?.length) {
    return null
  }

  return (
    <ProductPromotionHighlight
      promotions={promotions}
      className={csx({ zIndex: 1 })}
    />
  )
}

export type ProductSkuHighlightedPromotionProps = {
  productSkuRef: ProductSkuHighlightedPromotion_ProductSku$key
}

export const ProductSkuHighlightedPromotion = (
  props: ProductSkuHighlightedPromotionProps
) => (
  <Suspense fallback={null}>
    <ProductSkuHighlightedPromotionContent {...props} />
  </Suspense>
)
